import {UntypedFormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export const identityRevealedValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const email = control.get('email');
  const confirmEmail = control.get('confirm_email');
  return (email.value != null && confirmEmail && confirmEmail.value != null)
    && (email.value === '' || !confirmEmail || confirmEmail.value === '' || email.value !== confirmEmail.value)
    ? {mismatchedEmail: true} : null;
};
